/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, {useState} from 'react';
import {Platform} from 'react-native';
import {getCountryCodeFromName} from '../../common/utils/countryUtils';
import {
  AgeRapatriementCategory,
  assuredRapatriementAgeIsDifferentFromDevis,
  countPersonsRapatriementInAgeRanges,
  generateUUID,
  replaceSpecialCharacters,
} from '../../common/utils/functions';
import {
  defaultAssured,
  initModalData,
  modalDatasModified,
  rapatriementAgeGap,
  showErrorAssuredDefault,
  showErrorAssuredSubmit,
  showErrorValuesRapatriementDefault,
  showErrorValuesRapatriementSubmit,
} from '../../data/constants/Assurance/AssuranceRapatriement/souscription';
import {
  IAssured,
  IErrorRapatriement,
  IValues,
  ModalDataDTO,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/souscription';

dayjs.extend(customParseFormat);

export const useFormSouscription = (
  data: IValues,
  setData: (value: any) => void,
  initData: IValues,
  Validate: any,
  onCancel: any,
  handleSave: any,
  user?: any,
) => {
  const [showErrors, setShowErrors] = React.useState({
    ...showErrorValuesRapatriementDefault,
  });
  const errors = React.useMemo(() => Validate(data), [data]);

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const [previousFirstAssured, setPreviousFirstAssured] =
    useState<IAssured | null>(null);

  const handleChange = (name: keyof IValues, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    if (name !== 'userIsAssured') {
      setData({...data, [name]: value});
    } else {
      setData(
        (prevValues: IValues) =>
          ({
            ...prevValues,
            [name]: value,
            assure: [
              ...prevValues.assure.map((currentAssured, index: number) => {
                if (index === 0 && currentAssured.isEditable) {
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  const lastData = previousFirstAssured || {
                    nom: user.nom,
                    prenom: user.prenom,
                    dateNaissance: dayjs(
                      user.dateNaissance,
                      'DD/MM/YYYY',
                    ).toDate(),
                    sexe: user.sexe || '',
                    adressePostale: user.adressePostale || '',
                    ville: user.ville || '',

                    email: user.email || '',
                    telephone: user.telephone || '',
                    countryCode:
                      getCountryCodeFromName(currentAssured.paysResidence) ||
                      '',
                    numCI: '',
                    capture_file: previousFirstAssured
                      ? (previousFirstAssured as IAssured)?.capture_file || ''
                      : '',
                    lastCaptureFile: previousFirstAssured
                      ? (previousFirstAssured as IAssured)?.capture_file || ''
                      : '',
                    newImage: previousFirstAssured
                      ? (previousFirstAssured as IAssured)?.newImage || false
                      : false,
                    paysResidence: currentAssured.paysResidence || '',
                  };

                  const newAssured = {
                    // ...currentAssured,
                    ...lastData,
                    nom: replaceSpecialCharacters(lastData.nom)
                      .replace(/[^A-Za-z0-9 ]/g, ' ')
                      .toUpperCase(),
                    prenom: replaceSpecialCharacters(lastData.prenom)
                      .replace(/[^A-Za-z0-9 ]/g, ' ')
                      .toUpperCase(),
                    dateNaissance:
                      typeof lastData.dateNaissance == 'object'
                        ? lastData.dateNaissance
                        : dayjs(lastData.dateNaissance, 'DD/MM/YYYY').toDate(),
                    email: lastData.email,
                    telephone: lastData.telephone,
                    countryCode: lastData.countryCode,
                    isEditable: true,
                  };
                  setPreviousFirstAssured(() => currentAssured);

                  return newAssured;
                } else return {...currentAssured};
              }),
            ],
          } as any),
      );
    }
  };

  const noError = (errors: IErrorRapatriement) => {
    let bNoError = true;
    Object.entries(errors).forEach(element => {
      const errorsException: Array<string> = [
        'assure',
        'userIsAssured',
        'lastCaptureFile',
      ];
      if (element[1] !== '' && !errorsException.includes(element[0])) {
        bNoError = false;
      } else if (element[0] === 'assure' && element[1].length) {
        element[1].map((assureElt: any) => {
          const assureEltException: Array<string> = [
            'id',
            'newImage',
            'isEditable',
            'isNew',
          ];

          Object.entries(assureElt).forEach(assureEltProperty => {
            if (
              assureEltProperty[1] !== '' &&
              !assureEltException.includes(assureEltProperty[0])
            ) {
              bNoError = false;
            }
          });
        });
      }
    });
    return bNoError;
  };

  // const listMenuNotOk = (errors: any) => {
  //   errors.assure?.length &&
  //     errors.assure.map((assureElt: any) => {
  //       let assureEltStatus: 'sante' | 'renseignement' | undefined = undefined;
  //       Object.entries(assureElt).map((assureEltProperty: any) => {
  //         if (
  //           assureEltProperty[1] &&
  //           assureEltStatus !== 'renseignement' &&
  //           listRenseignement.includes(assureEltProperty[0])
  //         ) {
  //           assureEltStatus = 'renseignement';
  //         }
  //       });
  //       assureEltStatus &&
  //         listAssured.push({id: assureElt.id, menu: assureEltStatus});
  //     });

  //   return listAssured;
  // };

  const handleSubmit = () => {
    setShowErrors({
      ...showErrorValuesRapatriementSubmit,
      assure: data.assure.length
        ? [
            ...data.assure.map((element: any) => ({
              ...showErrorAssuredSubmit,
              id: element.id,
            })),
          ]
        : [],
    });
    console.log(errors);

    if (noError(errors)) {
      const nbrAges = countPersonsRapatriementInAgeRanges(
        data.assure,
        rapatriementAgeGap,
        'dateNaissance',
      );
      const oldAges = countPersonsRapatriementInAgeRanges(
        initData.assure,
        rapatriementAgeGap,
        'dateNaissance',
      );

      if (assuredRapatriementAgeIsDifferentFromDevis(nbrAges, oldAges)) {
        setModalData({
          status: true,
          title: 'Information',
          content: `Il y a une incohérence entre les informations du devis et celles de la souscription:\n
          \SOUSCRIPTION => DEVIS\n
          ${(
            Object.keys(rapatriementAgeGap) as (keyof AgeRapatriementCategory)[]
          )
            .reduce((acc, range) => {
              if (nbrAges[range] !== oldAges[range]) {
                acc.push(
                  `Entre ${rapatriementAgeGap[range].min} et ${rapatriementAgeGap[range].max} ans: ${nbrAges[range]} => ${oldAges[range]}`,
                );
              }
              return acc;
            }, [] as string[])
            .join('\n')}`,
          btn1: 'Poursuivre',
          btn2: 'Rectifier Souscription',
          handleBtn1: () => {
            handleSave(data);
          },
          handleBtn2: () => setModalData({...initModalData}),
        });
      } else {
        handleSave(data);
      }
    }
  };

  const handleAddAssured = (
    nbrAssured?: number,
    accept: boolean = false,
    init: boolean = false,
  ) => {
    const nbr: number = nbrAssured || 1;

    if (!accept) {
      setModalData({
        status: true,
        title: modalDatasModified.title,
        content: modalDatasModified.content,
        btn1: modalDatasModified.btn1,
        btn2: modalDatasModified.btn2,
        handleBtn1: () => {
          handleAddAssured(1, true);
          setModalData({...initModalData});
        },
        handleBtn2: () => setModalData({...initModalData}),
      });
    } else {
      const currentIDs: string[] = Array.from({length: nbr}, generateUUID);

      const updateAssuredArray = (prevAssured: any[], defaultAssured: any) =>
        prevAssured.concat(currentIDs.map(id => ({...defaultAssured, id})));

      setData((prevDatas: any) => ({
        ...prevDatas,
        assure: init
          ? updateAssuredArray([], defaultAssured)
          : updateAssuredArray(prevDatas.assure, defaultAssured),
      }));

      setShowErrors((prevShow: any) => ({
        ...prevShow,
        assure: init
          ? updateAssuredArray([], showErrorAssuredDefault)
          : updateAssuredArray(prevShow.assure, showErrorAssuredDefault),
      }));
    }
  };

  const handleInitValues = () => {
    setData({
      ...data,
      dateDebut: data.dateDebut || new Date(),
      assure: data.assure.map((a, index) => {
        if (typeof a.capture_file == 'string') {
          const tmpBlob = new Blob([''], {type: 'image/jpeg'});
          const tmpFile = new File([tmpBlob], `assured_${index}`, {
            type: 'image/jpeg',
          });
          return {
            ...a,
            lastCaptureFile:
              typeof a.capture_file == 'string'
                ? a.capture_file
                : a.lastCaptureFile,
            capture_file: [tmpFile],
          };
        }
        return a;
      }),
    });
  };

  const handleRemoveAssured = (id: string, accept: boolean = false) => {
    if (!accept) {
      setModalData({
        status: true,
        title: modalDatasModified.title,
        content: modalDatasModified.content,
        btn1: modalDatasModified.btn1,
        btn2: modalDatasModified.btn2,
        handleBtn1: () => {
          handleRemoveAssured(id, true);
          setModalData({...initModalData});
        },
        handleBtn2: () => setModalData({...initModalData}),
      });
    } else {
      setData((prevDatas: IValues) => ({
        ...prevDatas,
        assure: [
          ...prevDatas.assure.filter((element: any) => element.id !== id),
        ],
      }));
      setShowErrors((prevShow: any) => ({
        ...prevShow,
        assure: [
          ...prevShow.assure.filter((element: any) => element.id !== id),
        ],
      }));
    }
  };

  const handleChangeAssured = (
    id: string,
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    setShowErrors((prevErrors: any) => ({
      ...prevErrors,
      assure: [
        ...prevErrors.assure.map((element: any) => {
          if (element.id !== id) {
            return element;
          } else {
            return {
              ...element,
              [name]: value !== fired,
            };
          }
        }),
      ],
    }));

    const listToUpperCase: Array<string> = ['nom', 'prenom'];

    setData((prevValues: IValues) => {
      return {
        ...prevValues,
        assure: [
          ...prevValues.assure.map((assureElt: any) => {
            if (assureElt.id !== id) {
              return assureElt;
            } else {
              if (name === 'capture_file') {
                const _value =
                  Platform.OS !== 'web'
                    ? {
                        uri: value?.uri,
                        type: value?.type,
                        name: value?.fileName,
                      }
                    : value;

                if (remove) {
                  return {
                    ...assureElt,
                    [name]: [],
                  };
                }

                const images: Array<any> = assureElt[name]
                  ? [...assureElt[name]]
                  : [];
                images.push(_value);

                return {
                  ...assureElt,
                  [name]: images,
                  newImage: true,
                };
              } else if (listToUpperCase.includes(name)) {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)?.replace(
                          /[^A-Za-z0-9 ]/g,
                          '',
                        )
                      : value,
                };
              } else {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)
                      : value,
                };
              }
            }
          }),
        ],
      };
    });
  };

  const handleCancel = () => {
    setData(initData);
    onCancel();
  };

  return {
    handleChange,
    handleSubmit,
    isDisable: !!data.assure.length,
    handleCancel,
    values: data,
    errors: errors,
    showErrors,
    handleAddAssured,
    handleRemoveAssured,
    handleChangeAssured,
    handleInitValues,
    modalData,
  };
};
